// Comprehensive catering menu items sourced from Chennai Catering Service
export const TIFFIN_MENU_ITEMS = [
  // Soup
  { name: 'Veg Clear Soup', category: 'Soup', defaultPrice: 40 },
  { name: 'Tomato Soup', category: 'Soup', defaultPrice: 40 },
  { name: 'Sweet Corn Soup', category: 'Soup', defaultPrice: 50 },
  { name: 'Mushroom Soup', category: 'Soup', defaultPrice: 55 },
  { name: 'Mutton Bone Soup', category: 'Soup', defaultPrice: 80 },
  { name: 'Chicken Soup', category: 'Soup', defaultPrice: 70 },
  { name: 'Crab Soup', category: 'Soup', defaultPrice: 90 },
  { name: 'Lemon Coriander Soup', category: 'Soup', defaultPrice: 45 },
  { name: 'Cream Of Tomato', category: 'Soup', defaultPrice: 50 },
  { name: 'Cream Of Mushroom', category: 'Soup', defaultPrice: 60 },
  { name: 'Veg Manchow', category: 'Soup', defaultPrice: 50 },
  { name: 'Veg Hot & Sour', category: 'Soup', defaultPrice: 50 },
  { name: 'Veg Noodle Soup', category: 'Soup', defaultPrice: 50 },
  { name: 'Veg Sweet Corn Soup', category: 'Soup', defaultPrice: 50 },

  // Idly Varieties
  { name: 'Idly', category: 'Idly Varieties', defaultPrice: 30 },
  { name: 'Mini Idly', category: 'Idly Varieties', defaultPrice: 35 },
  { name: 'Sambar Idly', category: 'Idly Varieties', defaultPrice: 40 },
  { name: 'Tandoori Idly', category: 'Idly Varieties', defaultPrice: 45 },
  { name: 'Fried Idly', category: 'Idly Varieties', defaultPrice: 40 },
  { name: 'Idly Vadakari', category: 'Idly Varieties', defaultPrice: 45 },
  { name: 'Hearten Idly', category: 'Idly Varieties', defaultPrice: 40 },
  { name: 'Thattu Idly', category: 'Idly Varieties', defaultPrice: 35 },
  { name: 'Elaneer Idly', category: 'Idly Varieties', defaultPrice: 45 },
  { name: 'Pepper Idly', category: 'Idly Varieties', defaultPrice: 40 },
  { name: 'Veg Mix Idly', category: 'Idly Varieties', defaultPrice: 45 },
  { name: 'Ghee Podi Idly', category: 'Idly Varieties', defaultPrice: 45 },

  // Dosa Varieties
  { name: 'Plain Dosa', category: 'Dosa Varieties', defaultPrice: 35 },
  { name: 'Masala Dosa', category: 'Dosa Varieties', defaultPrice: 50 },
  { name: 'Mysore Masala Dosa', category: 'Dosa Varieties', defaultPrice: 55 },
  { name: 'Ghee Dosa', category: 'Dosa Varieties', defaultPrice: 45 },
  { name: 'Tomato Dosa', category: 'Dosa Varieties', defaultPrice: 40 },
  { name: 'Podi Dosa', category: 'Dosa Varieties', defaultPrice: 40 },
  { name: 'Ghee Podi Dosa', category: 'Dosa Varieties', defaultPrice: 50 },
  { name: 'Butter Dosa', category: 'Dosa Varieties', defaultPrice: 45 },
  { name: 'Carrot Dosa', category: 'Dosa Varieties', defaultPrice: 45 },
  { name: 'Malli Dosa', category: 'Dosa Varieties', defaultPrice: 45 },
  { name: 'Veg Mix Uttapam', category: 'Dosa Varieties', defaultPrice: 50 },

  // Tiffin & Breakfast
  { name: 'Pongal', category: 'Tiffin & Breakfast', defaultPrice: 40 },
  { name: 'Ghee Pongal', category: 'Tiffin & Breakfast', defaultPrice: 50 },
  { name: 'Vada', category: 'Tiffin & Breakfast', defaultPrice: 25 },
  { name: 'Poori', category: 'Tiffin & Breakfast', defaultPrice: 40 },
  { name: 'Upma', category: 'Tiffin & Breakfast', defaultPrice: 30 },
  { name: 'Kesari', category: 'Tiffin & Breakfast', defaultPrice: 35 },
  { name: 'Pineapple Kesari', category: 'Tiffin & Breakfast', defaultPrice: 40 },
  { name: 'Idiyappam', category: 'Tiffin & Breakfast', defaultPrice: 35 },
  { name: 'Appam', category: 'Tiffin & Breakfast', defaultPrice: 35 },
  { name: 'Paniyaram', category: 'Tiffin & Breakfast', defaultPrice: 30 },
  { name: 'Lemon Sevai', category: 'Tiffin & Breakfast', defaultPrice: 35 },
  { name: 'Tomato Sevai', category: 'Tiffin & Breakfast', defaultPrice: 35 },
  { name: 'Veg Mix Kichadi', category: 'Tiffin & Breakfast', defaultPrice: 40 },

  // Roti & Bread
  { name: 'Roti', category: 'Roti & Bread', defaultPrice: 15 },
  { name: 'Chapati', category: 'Roti & Bread', defaultPrice: 15 },
  { name: 'Naan', category: 'Roti & Bread', defaultPrice: 20 },
  { name: 'Butter Naan', category: 'Roti & Bread', defaultPrice: 25 },
  { name: 'Garlic Naan', category: 'Roti & Bread', defaultPrice: 30 },
  { name: 'Pulka', category: 'Roti & Bread', defaultPrice: 15 },
  { name: 'Kulcha', category: 'Roti & Bread', defaultPrice: 25 },
  { name: 'Rumali Roti', category: 'Roti & Bread', defaultPrice: 20 },
  { name: 'Badura', category: 'Roti & Bread', defaultPrice: 20 },

  // Parotta
  { name: 'Parotta', category: 'Parotta', defaultPrice: 25 },
  { name: 'Chilli Parotta', category: 'Parotta', defaultPrice: 45 },
  { name: 'Veg Cyma Parotta', category: 'Parotta', defaultPrice: 50 },
  { name: 'Egg Parotta', category: 'Parotta', defaultPrice: 40 },
  { name: 'Chicken Parotta', category: 'Parotta', defaultPrice: 60 },
  { name: 'Mutton Cyma Parotta', category: 'Parotta', defaultPrice: 70 },
  { name: 'Stuffed Parotta', category: 'Parotta', defaultPrice: 35 },
  { name: 'Coin Parotta', category: 'Parotta', defaultPrice: 30 },
  { name: 'Aloo Parotta', category: 'Parotta', defaultPrice: 35 },
  { name: 'Wheat Parotta', category: 'Parotta', defaultPrice: 30 },

  // Rice
  { name: 'Steamed Rice', category: 'Rice', defaultPrice: 30 },
  { name: 'Ghee Rice', category: 'Rice', defaultPrice: 60 },
  { name: 'Sambar Rice', category: 'Rice', defaultPrice: 50 },
  { name: 'Curd Rice', category: 'Rice', defaultPrice: 40 },
  { name: 'Lemon Rice', category: 'Rice', defaultPrice: 45 },
  { name: 'Tomato Rice', category: 'Rice', defaultPrice: 45 },
  { name: 'Tamarind Rice', category: 'Rice', defaultPrice: 45 },
  { name: 'Coconut Rice', category: 'Rice', defaultPrice: 45 },
  { name: 'Jeera Rice', category: 'Rice', defaultPrice: 50 },
  { name: 'Curd Semiya', category: 'Rice', defaultPrice: 40 },
  { name: 'Kambu Curd Rice', category: 'Rice', defaultPrice: 45 },

  // Biryani & Pulav
  { name: 'Veg Biryani', category: 'Biryani & Pulav', defaultPrice: 80 },
  { name: 'Chicken Biryani', category: 'Biryani & Pulav', defaultPrice: 120 },
  { name: 'Mutton Biryani', category: 'Biryani & Pulav', defaultPrice: 150 },
  { name: 'Egg Biryani', category: 'Biryani & Pulav', defaultPrice: 90 },
  { name: 'Fish Biryani', category: 'Biryani & Pulav', defaultPrice: 130 },
  { name: 'Quail Biryani', category: 'Biryani & Pulav', defaultPrice: 160 },
  { name: 'Hyderabad Veg Biryani', category: 'Biryani & Pulav', defaultPrice: 90 },
  { name: 'Malabar Biryani', category: 'Biryani & Pulav', defaultPrice: 100 },
  { name: 'Veg Pulav', category: 'Biryani & Pulav', defaultPrice: 60 },
  { name: 'Peas Pulav', category: 'Biryani & Pulav', defaultPrice: 60 },
  { name: 'Paneer Pulav', category: 'Biryani & Pulav', defaultPrice: 70 },
  { name: 'Mushroom Pulav', category: 'Biryani & Pulav', defaultPrice: 70 },

  // Veg Gravy
  { name: 'Paneer Butter Masala', category: 'Veg Gravy', defaultPrice: 70 },
  { name: 'Chenna Masala', category: 'Veg Gravy', defaultPrice: 50 },
  { name: 'Gobi Masala', category: 'Veg Gravy', defaultPrice: 45 },
  { name: 'Aloo Gobi Masala', category: 'Veg Gravy', defaultPrice: 45 },
  { name: 'Palak Paneer', category: 'Veg Gravy', defaultPrice: 65 },
  { name: 'Mixed Veg Gravy', category: 'Veg Gravy', defaultPrice: 50 },
  { name: 'Gobi Manchurian Gravy', category: 'Veg Gravy', defaultPrice: 55 },
  { name: 'Malai Kofta', category: 'Veg Gravy', defaultPrice: 60 },
  { name: 'Veg Kofta', category: 'Veg Gravy', defaultPrice: 55 },
  { name: 'Mutter Paneer Gravy', category: 'Veg Gravy', defaultPrice: 65 },
  { name: 'Green Peas Masala', category: 'Veg Gravy', defaultPrice: 45 },
  { name: 'Mushroom Masala', category: 'Veg Gravy', defaultPrice: 60 },
  { name: 'Mushroom Manchurian', category: 'Veg Gravy', defaultPrice: 60 },
  { name: 'Veg Kadai Masala', category: 'Veg Gravy', defaultPrice: 55 },
  { name: 'Veg Mix Masala', category: 'Veg Gravy', defaultPrice: 50 },
  { name: 'Veg Stew', category: 'Veg Gravy', defaultPrice: 45 },
  { name: 'Sambar', category: 'Veg Gravy', defaultPrice: 30 },
  { name: 'Rasam', category: 'Veg Gravy', defaultPrice: 25 },
  { name: 'Dal', category: 'Veg Gravy', defaultPrice: 35 },

  // Non-Veg Dishes
  { name: 'Chicken 65', category: 'Non-Veg Dishes', defaultPrice: 80 },
  { name: 'Chicken Pepper Gravy', category: 'Non-Veg Dishes', defaultPrice: 90 },
  { name: 'Chettinad Chicken Gravy', category: 'Non-Veg Dishes', defaultPrice: 100 },
  { name: 'Butter Chicken Masala', category: 'Non-Veg Dishes', defaultPrice: 110 },
  { name: 'Grilled Chicken', category: 'Non-Veg Dishes', defaultPrice: 120 },
  { name: 'Tandoori Chicken', category: 'Non-Veg Dishes', defaultPrice: 130 },
  { name: 'Mutton Liver Fry', category: 'Non-Veg Dishes', defaultPrice: 100 },
  { name: 'Mutton Masala', category: 'Non-Veg Dishes', defaultPrice: 140 },
  { name: 'Mutton Fry', category: 'Non-Veg Dishes', defaultPrice: 130 },
  { name: 'Mutton Leg Gravy', category: 'Non-Veg Dishes', defaultPrice: 160 },
  { name: 'Mutton Brain Fry', category: 'Non-Veg Dishes', defaultPrice: 120 },
  { name: 'Mutton Head Fry', category: 'Non-Veg Dishes', defaultPrice: 150 },
  { name: 'Quail Fry', category: 'Non-Veg Dishes', defaultPrice: 120 },
  { name: 'Quail 65', category: 'Non-Veg Dishes', defaultPrice: 110 },
  { name: 'Crab Roast', category: 'Non-Veg Dishes', defaultPrice: 140 },
  { name: 'Prawn Fry', category: 'Non-Veg Dishes', defaultPrice: 130 },
  { name: 'Fish Fry', category: 'Non-Veg Dishes', defaultPrice: 100 },

  // Fried Rice & Noodles
  { name: 'Veg Noodles', category: 'Fried Rice & Noodles', defaultPrice: 60 },
  { name: 'Veg Schezwan Noodles', category: 'Fried Rice & Noodles', defaultPrice: 70 },
  { name: 'Chicken Fried Rice', category: 'Fried Rice & Noodles', defaultPrice: 80 },
  { name: 'Chicken Noodles', category: 'Fried Rice & Noodles', defaultPrice: 80 },
  { name: 'Mutton Fried Rice', category: 'Fried Rice & Noodles', defaultPrice: 100 },
  { name: 'Mutton Noodles', category: 'Fried Rice & Noodles', defaultPrice: 100 },
  { name: 'Egg Fried Rice', category: 'Fried Rice & Noodles', defaultPrice: 70 },
  { name: 'Egg Noodles', category: 'Fried Rice & Noodles', defaultPrice: 70 },

  // Veg Starters
  { name: 'Gopi 65', category: 'Veg Starters', defaultPrice: 55 },
  { name: 'Mushroom 65', category: 'Veg Starters', defaultPrice: 60 },
  { name: 'Stuffed Mushroom', category: 'Veg Starters', defaultPrice: 65 },
  { name: 'Gopi Lollipop', category: 'Veg Starters', defaultPrice: 55 },
  { name: 'Aloo Jeera', category: 'Veg Starters', defaultPrice: 40 },
  { name: 'Paneer 65', category: 'Veg Starters', defaultPrice: 70 },
  { name: 'Paneer Schezwan', category: 'Veg Starters', defaultPrice: 75 },
  { name: 'Veg Ball Manchurian', category: 'Veg Starters', defaultPrice: 55 },
  { name: 'Cheese Corn Ball', category: 'Veg Starters', defaultPrice: 60 },
  { name: 'Baby Corn 65', category: 'Veg Starters', defaultPrice: 55 },
  { name: 'Baby Corn Salt & Pepper', category: 'Veg Starters', defaultPrice: 55 },

  // Salad
  { name: 'Veg Salad', category: 'Salad', defaultPrice: 25 },
  { name: 'Cucumber Salad', category: 'Salad', defaultPrice: 20 },
  { name: 'Onion Salad', category: 'Salad', defaultPrice: 15 },
  { name: 'Fruit Salad', category: 'Salad', defaultPrice: 50 },
  { name: 'Green Salad', category: 'Salad', defaultPrice: 25 },
  { name: 'Tossed Salad', category: 'Salad', defaultPrice: 30 },
  { name: 'Russian Salad', category: 'Salad', defaultPrice: 40 },
  { name: 'Raita', category: 'Salad', defaultPrice: 20 },

  // Side Dish
  { name: 'Coconut Chutney', category: 'Side Dish', defaultPrice: 15 },
  { name: 'Tomato Chutney', category: 'Side Dish', defaultPrice: 15 },
  { name: 'Mint Chutney', category: 'Side Dish', defaultPrice: 15 },
  { name: 'Onion Chutney', category: 'Side Dish', defaultPrice: 15 },
  { name: 'Peanut Chutney', category: 'Side Dish', defaultPrice: 15 },
  { name: 'Potato Curry', category: 'Side Dish', defaultPrice: 25 },
  { name: 'Papad', category: 'Side Dish', defaultPrice: 10 },
  { name: 'Pickle', category: 'Side Dish', defaultPrice: 10 },

  // Snacks
  { name: 'Bajji', category: 'Snacks', defaultPrice: 30 },
  { name: 'Bonda', category: 'Snacks', defaultPrice: 25 },
  { name: 'Pakoda', category: 'Snacks', defaultPrice: 35 },
  { name: 'Samosa', category: 'Snacks', defaultPrice: 20 },
  { name: 'Cutlet', category: 'Snacks', defaultPrice: 25 },
  { name: 'Veg Spring Roll', category: 'Snacks', defaultPrice: 40 },
  { name: 'Pasta Varieties', category: 'Snacks', defaultPrice: 60 },

  // Sweets & Desserts
  { name: 'Gulab Jamun', category: 'Sweets & Desserts', defaultPrice: 25 },
  { name: 'Rasamalai', category: 'Sweets & Desserts', defaultPrice: 35 },
  { name: 'Rasagulla', category: 'Sweets & Desserts', defaultPrice: 30 },
  { name: 'Jalebi', category: 'Sweets & Desserts', defaultPrice: 30 },
  { name: 'Chocolate Cake', category: 'Sweets & Desserts', defaultPrice: 50 },
  { name: 'Ghee Mysore Pak', category: 'Sweets & Desserts', defaultPrice: 35 },
  { name: 'Pumpkin Halwa', category: 'Sweets & Desserts', defaultPrice: 30 },
  { name: 'Carrot Halwa', category: 'Sweets & Desserts', defaultPrice: 35 },
  { name: 'Makenpeda', category: 'Sweets & Desserts', defaultPrice: 30 },
  { name: 'Coconut Pudding', category: 'Sweets & Desserts', defaultPrice: 35 },
  { name: 'Ice Cream With Jamun', category: 'Sweets & Desserts', defaultPrice: 45 },
  { name: 'Ice Cream With Halwa', category: 'Sweets & Desserts', defaultPrice: 45 },
  { name: 'Ice Cream Varieties', category: 'Sweets & Desserts', defaultPrice: 40 },
  { name: 'Fried Ice Cream', category: 'Sweets & Desserts', defaultPrice: 50 },
  { name: 'Ladoo', category: 'Sweets & Desserts', defaultPrice: 20 },

  // Beverages & Welcome Drinks
  { name: 'Filter Coffee', category: 'Beverages', defaultPrice: 20 },
  { name: 'Tea', category: 'Beverages', defaultPrice: 15 },
  { name: 'Lemon Tea', category: 'Beverages', defaultPrice: 20 },
  { name: 'Masala Tea', category: 'Beverages', defaultPrice: 20 },
  { name: 'Buttermilk', category: 'Beverages', defaultPrice: 15 },
  { name: 'Badam Milk', category: 'Beverages', defaultPrice: 30 },
  { name: 'Pista Milk', category: 'Beverages', defaultPrice: 35 },
  { name: 'Grape Juice', category: 'Beverages', defaultPrice: 30 },
  { name: 'Lemon Juice', category: 'Beverages', defaultPrice: 20 },
  { name: 'Orange Juice', category: 'Beverages', defaultPrice: 30 },
  { name: 'Pineapple Juice', category: 'Beverages', defaultPrice: 30 },
  { name: 'Nannari Sarbath', category: 'Beverages', defaultPrice: 25 },
  { name: 'Panagam', category: 'Beverages', defaultPrice: 15 },

  // Special Items
  { name: 'Elai Parotta', category: 'Special Items', defaultPrice: 40 },
];

export const getItemsByCategory = (category) => {
  return TIFFIN_MENU_ITEMS.filter(item => item.category === category);
};

export const getAllCategories = () => {
  return [...new Set(TIFFIN_MENU_ITEMS.map(item => item.category))];
};
